export default "__VITE_ASSET__Bm9MyifG__"